<script lang="ts">
export default {
  name: 'AnnouncementsButton',
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import { AlertCircle, Megaphone } from '@lucide/vue';
import Alert from '@/components/v2/Alert.vue';
import AppModal from '@/components/v2/AppModal.vue';
import { useAnnouncements } from '@/composables/useAnnouncements';

const { announcements, dismissedAnnouncements } = useAnnouncements();
const showModal = ref(false);
</script>

<template>
  <div
    v-if="dismissedAnnouncements.length"
    class="ml-2 flex h-full items-center">
    <button
      type="button"
      title="Platform Notices"
      aria-label="Platform Notices"
      data-testid="announcements-button"
      class="group btn border-none btn-ghost btn-lg hover:border-none hover:bg-white/10 hover:shadow-none transition-colors"
      @click="showModal = true">
      <Megaphone
        :size="19"
        class="stroke-white group-hover:rotate-12" />
    </button>

    <AppModal
      :show="showModal"
      title="Platform Notices"
      size="lg"
      :handle-cancel="() => (showModal = false)">
      <template #content>
        <div
          class="flex flex-col gap-3"
          data-testid="announcements-modal">
          <Alert
            v-for="announcement in announcements"
            :key="announcement.id"
            :type="announcement.severity"
            :icon="AlertCircle"
            :data-testid="`announcement-notice-${announcement.type}`">
            <span class="font-normal">{{ announcement.text }}</span>
          </Alert>
        </div>
      </template>
      <template #actions>
        <button
          class="btn btn-sm"
          @click="showModal = false">
          Close
        </button>
      </template>
    </AppModal>
  </div>
</template>
